<template>
    <slot></slot>
    <LayoutAlerts v-model="messages" />
    <ModalConfirm
        v-if="globalConfirm.show"
        v-model="globalConfirm.show"
        show-shortcut
        :modal-data="globalConfirm.data"
        :show-x-button="globalConfirm?.data?.showXButton"
        @cta="globalConfirm.ctaCallback"
        @cancel="globalConfirm.cancelCallback"
    />
    <vModalLayouts />
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LayoutAlerts } from "@easy/ui/layouts";
import { darkModeService } from "@/shared/themes/dark-mode.service";
import { useUserAuth } from "@/shared/user/useUserAuth";
import { ModalConfirm } from "@easy/ui/modals";
import vModalLayouts from "@/shared/views/vModalLayouts.vue";
import { languageService } from "@/shared/user/language.service";
import { useCleanQueryParams } from "@/shared/utils/router/useCleanQueryParams";

import("@easy/ui/style.css");

const toNewFormatMapper = (alert) => ({
    message: alert.text,
    ...alert,
    // map to proper "error" / "success" / "warning" type
    type: alert.type === "wrong" ? "error" : alert.type,
});

export default {
    components: {
        LayoutAlerts,
        ModalConfirm,
        vModalLayouts,
    },
    setup() {
        const { cleanQueryParams } = useCleanQueryParams();
        darkModeService.init();
        languageService.init();
        // remove params here (caused by racing condition):
        cleanQueryParams(["lang", "theme"]);
        useUserAuth();
    },
    created() {
        this.registerGlobalConfirmModalCallbacks({
            cta: () => true,
            cancel: () => false,
        });
        // store.alerts NEED to be rewritten this way for OBSERVABILITY !!!
        this.$store.subscribe(this.addNewAlertMessage);
    },
    beforeUnmount() {
        this.$store?.unsubscribe?.(this.addNewAlertMessage);
    },
    data() {
        return { allMessages: [] };
    },
    computed: {
        ...mapState("alert", ["messages"]),
        ...mapState("modals", ["globalConfirm"]),
    },
    methods: {
        ...mapActions("modals", ["registerGlobalConfirmModalCallbacks"]),
        // Legacy alerts:
        addNewAlertMessage(mutation) {
            if (mutation.type === "showAlert") {
                this.messages.push(toNewFormatMapper(mutation.payload));
            }
        },
    },
};
</script>
